<template>
  <header class="site-header-modern">
    <div class="header-inner">
      <div class="header-logo">
        <a :href="homepage">
          <img :src="logo" alt="logo">
        </a>
      </div>
      <nav class="header-nav">
        <ul class="nav-list">
          <li
            v-for="(item, index) in links"
            :key="index"
            class="nav-item"
            :class="{'has-children': item.children, 'child-active': isChildActive(item)}"
          >
            <button v-if="item.children" type="button" class="nav-parent">
              {{ item.name }}<span class="menu-chevron"></span>
            </button>
            <router-link v-else :to="item.link" exact-active-class="active">{{ item.name }}</router-link>
            <div v-if="item.children" class="nav-dropdown">
              <router-link
                v-for="child in item.children"
                :key="child.link"
                :to="child.link"
                exact-active-class="active"
              >{{ child.name }}</router-link>
            </div>
          </li>
        </ul>
      </nav>
      <div class="header-actions">
        <div class="lang-change" @click="changeLanguage">
          <span :class="{active: lang === 'zh'}">中文</span>
          <span class="lang-divider">/</span>
          <span :class="{active: lang === 'en'}">EN</span>
        </div>
        <button class="search-btn" @click="toggleSearch">
          <span class="search-icon"></span>
        </button>
        <button
          class="mobile-menu-btn"
          :class="{open: isMobileMenuOpen}"
          @click="toggleMobileMenu"
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </div>

    <!-- Mobile Menu -->
    <transition name="slide">
      <div
        v-show="isMobileMenuOpen"
        class="mobile-menu"
        ref="mobileMenu"
      >
        <ul class="mobile-nav-list">
          <li
            v-for="(item, index) in links"
            :key="index"
            class="mobile-nav-item"
          >
            <button
              v-if="item.children"
              type="button"
              class="mobile-nav-parent"
              :class="{open: isMobileAppMenuOpen}"
              @click="toggleMobileAppMenu"
            >
              {{ item.name }}<span class="menu-chevron"></span>
            </button>
            <div v-if="item.children" v-show="isMobileAppMenuOpen" class="mobile-submenu">
              <router-link
                v-for="child in item.children"
                :key="child.link"
                :to="child.link"
                exact-active-class="active"
                @click.native="closeMobileMenu"
              >{{ child.name }}</router-link>
            </div>
            <router-link
              v-else
              :to="item.link"
              exact-active-class="active"
              @click.native="closeMobileMenu"
            >{{ item.name }}</router-link>
          </li>
        </ul>
        <div class="mobile-lang-change" @click="changeLanguage">
          <span :class="{active: lang === 'zh'}">中文</span>
          <span class="lang-divider">/</span>
          <span :class="{active: lang === 'en'}">EN</span>
        </div>
      </div>
    </transition>

    <!-- Overlay -->
    <transition name="fade">
      <div
        v-show="isMobileMenuOpen"
        class="mobile-overlay"
        @click="closeMobileMenu"
      ></div>
    </transition>
  </header>
</template>

<script>
export default {
  data() {
    return {
      isMobileMenuOpen: false,
      isMobileAppMenuOpen: false
    };
  },
  computed: {
    homepage() {
      if (window.location.href.indexOf('mltcloud.com') !== -1) {
        document.title = '美乐创';
        return 'http://www.mltcloud.com/';
      }
      return 'http://www.cashzp.com/';
    },
    lang() {
      let srcLan = this.$i18n.locale;
      if (srcLan.indexOf('en') !== -1) {
        return 'en';
      }
      return 'zh';
    },
    logo() {
       return require(`@/assets/images/mllogo.png`);
      if (window.location.href.indexOf('mltcloud.com') !== -1) {
        return require(`@/assets/images/mllogo.png`);
      }
      return require(`@/assets/images/logo-1-${this.lang}.png`);
    },
    links() {
      return [
        { name: this.$t("nav.home"), link: "/" },
        { name: this.$t("nav.products"), link: "/products" },
        {
          name: this.$t("nav.app_download"),
          children: [
            { name: this.$t("nav.leecho"), link: "/leecho" },
            { name: this.$t("nav.levue"), link: "/levue" },
            { name: this.$t("nav.lebond"), link: "/lebond" },
            { name: this.$t("nav.lesound"), link: "/lesound" }
          ]
        },
        { name: this.$t("nav.contact"), link: "/contact" },
        { name: this.$t("nav.about"), link: "/about" }
      ];
    }
  },
  methods: {
    changeLanguage() {
      let srcLan = this.lang;
      if (srcLan.indexOf('en') !== -1) {
        srcLan = 'zh';
      } else {
        srcLan = 'en';
      }
      if (window.location.href.indexOf('mltcloud.com') !== -1) {
        srcLan += '_ml';
      }
       srcLan += '_ml';
      this.$i18n.locale = srcLan;
      this.$forceUpdate();
    },
    toggleSearch() {
      // placeholder for search functionality
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    toggleMobileAppMenu() {
      this.isMobileAppMenuOpen = !this.isMobileAppMenuOpen;
    },
    isChildActive(item) {
      return item.children && item.children.some(child => child.link === this.$route.path);
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false;
      this.isMobileAppMenuOpen = false;
    },
    handleOutsideClick(e) {
      const header = this.$el;
      if (header && !header.contains(e.target)) {
        this.closeMobileMenu();
      }
    }
  },
  watch: {
    isMobileMenuOpen(val) {
      if (val) {
        document.addEventListener('click', this.handleOutsideClick);
        document.body.style.overflow = 'hidden';
      } else {
        document.removeEventListener('click', this.handleOutsideClick);
        document.body.style.overflow = '';
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
    document.body.style.overflow = '';
  }
};
</script>

<style lang="stylus" scoped>
.site-header-modern {
  background: rgba(255, 255, 255, 0.92);
  border-bottom: 1px solid rgba(30, 54, 104, 0.08);
  box-shadow: 0 8px 30px rgba(22, 39, 76, 0.05);
  backdrop-filter: blur(18px);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.header-inner {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 78px;
}

.header-logo {
  a {
    display: block;
  }
  img {
    height: 46px;
    width: auto;
    display: block;
  }
}

.header-nav {
  flex: 1;
  display: flex;
  justify-content: center;
}

.nav-list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 34px;
}

.nav-item {
  position: relative;

  a {
    text-decoration: none;
    color: #263451;
    font-size: 15px;
    font-weight: 600;
    padding: 8px 0;
    position: relative;
    transition: color 0.3s ease;
    display: inline-block;

    &:hover {
      color: #2459d5;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 0;
      height: 2px;
      background-color: #2459d5;
      transition: width 0.3s ease;
    }

    &:hover::after,
    &.active::after {
      width: 100%;
    }

    &.active {
      color: #2459d5;
    }
  }

  &.has-children:hover .nav-dropdown,
  &.has-children:focus-within .nav-dropdown {
    opacity: 1;
    visibility: visible;
    transform: translate(-50%, 0);
    pointer-events: auto;
  }

  &.has-children:hover .menu-chevron,
  &.has-children:focus-within .menu-chevron {
    transform: rotate(225deg) translate(-2px, -2px);
  }
}

.nav-parent {
  appearance: none;
  border: 0;
  background: transparent;
  color: #263451;
  font-family: inherit;
  font-size: 15px;
  font-weight: 600;
  padding: 8px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: color 0.3s ease;
}

.child-active .nav-parent,
.nav-parent:hover {
  color: #2459d5;
}

.menu-chevron {
  width: 7px;
  height: 7px;
  border-right: 1.5px solid currentColor;
  border-bottom: 1.5px solid currentColor;
  transform: rotate(45deg) translate(-2px, -2px);
  transition: transform 0.25s ease;
}

.nav-dropdown {
  position: absolute;
  top: calc(100% + 14px);
  left: 50%;
  width: 168px;
  padding: 8px;
  background: #fff;
  border: 1px solid rgba(31, 55, 96, 0.08);
  border-radius: 16px;
  box-shadow: 0 22px 55px rgba(19, 35, 68, 0.16);
  opacity: 0;
  visibility: hidden;
  transform: translate(-50%, -8px);
  pointer-events: none;
  transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s ease;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: -16px;
    height: 16px;
  }

  a {
    display: block;
    padding: 11px 14px;
    border-radius: 9px;
    font-size: 14px;

    &::after {
      display: none;
    }

    &:hover,
    &.active {
      color: #315ee9;
      background: #f1f5ff;
    }
  }
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.lang-change {
  font-size: 13px;
  color: #72809a;
  cursor: pointer;
  user-select: none;

  span {
    transition: color 0.3s ease;

    &.active {
      color: #2459d5;
      font-weight: 600;
    }
  }

  .lang-divider {
    margin: 0 4px;
    color: #ccc;
  }
}

.search-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #2459d5;
  border: none;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s ease;
  padding: 0;

  &:hover {
    background: #1747bc;
  }

  .search-icon {
    display: block;
    width: 14px;
    height: 14px;
    border: 2px solid #fff;
    border-radius: 50%;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      width: 7px;
      height: 2px;
      background: #fff;
      bottom: -1px;
      right: -5px;
      transform: rotate(45deg);
      transform-origin: left center;
    }
  }
}

/* Mobile Menu Button */
.mobile-menu-btn {
  display: none;
  width: 40px;
  height: 40px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  position: relative;
  z-index: 1002;

  span {
    display: block;
    width: 24px;
    height: 2px;
    background: #333;
    transition: all 0.3s ease;
    border-radius: 1px;
  }

  &.open {
    span:nth-child(1) {
      transform: translateY(7px) rotate(45deg);
    }
    span:nth-child(2) {
      opacity: 0;
    }
    span:nth-child(3) {
      transform: translateY(-7px) rotate(-45deg);
    }
  }
}

/* Mobile Menu */
.mobile-menu {
  display: none;
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  z-index: 1001;
  overflow-y: auto;
  padding: 20px 24px 40px;
}

.mobile-nav-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.mobile-nav-item {
  a {
    display: block;
    padding: 16px 0;
    color: #333;
    text-decoration: none;
    font-size: 16px;
    font-weight: 500;
    border-bottom: 1px solid #f0f0f0;
    transition: color 0.3s ease;

    &:hover,
    &.active {
      color: #0066cc;
    }
  }

  &:last-child a {
    border-bottom: none;
  }
}

.mobile-nav-parent {
  width: 100%;
  padding: 16px 0;
  border: 0;
  border-bottom: 1px solid #f0f0f0;
  background: transparent;
  color: #333;
  font-family: inherit;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  &.open .menu-chevron {
    transform: rotate(225deg) translate(-2px, -2px);
  }
}

.mobile-submenu {
  padding: 4px 0 8px 16px;
  background: #f8faff;
  border-radius: 0 0 12px 12px;

  a {
    padding: 13px 14px;
    border-bottom: 0;
    border-radius: 8px;
    font-size: 15px;

    &.active {
      background: #edf2ff;
    }
  }
}

.mobile-lang-change {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 2px solid #f0f0f0;
  font-size: 15px;
  color: #666;
  cursor: pointer;
  text-align: center;

  span.active {
    color: #0066cc;
    font-weight: 600;
  }

  .lang-divider {
    margin: 0 8px;
    color: #ccc;
  }
}

/* Mobile Overlay */
.mobile-overlay {
  display: none;
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
}

/* Transitions */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.slide-enter,
.slide-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* Responsive */
@media (max-width: 768px) {
  .header-nav,
  .header-actions .lang-change,
  .search-btn {
    display: none;
  }

  .mobile-menu-btn {
    display: flex;
  }

  .mobile-menu,
  .mobile-overlay {
    display: block;
  }

  .header-logo img {
    height: 40px;
  }

  .header-inner {
    height: 60px;
  }
}

@media (max-width: 480px) {
  .header-inner {
    padding: 0 16px;
  }

  .header-logo img {
    height: 36px;
  }
}
</style>
